import ClimateControl from '@/icons/climate-control';
import WirelessDisplay from '@/icons/wireless-display';
import SafetyBelt from '@/icons/safety-belt';
import Drivetrain from '@/icons/drivetrain';
import Dimension from '@/icons/dimension';

export const CATEGORY_MAPPINGS = {
  features: {
    'Comfort and Convenience': 'Comfort & convenience',
    'Technology and Entertainment': 'Technology & connectivity',
    'Technology and Telematics': 'Technology & connectivity',
    'Safety and Security': 'Safety & security',
  },
  specifications: {
    'Powertrain and Mechanical': 'Performance & powertrain',
    'Fuel Economy and Emissions': 'Performance & powertrain',
    'Exterior and Appearance': 'Dimensions & capacity',
    'Interior Specs': 'Dimensions & capacity',
  },
} as const;

// Function to dynamically get allowed categories
export const getAllowedCategories = (section: keyof typeof CATEGORY_MAPPINGS) =>
  Object.keys(CATEGORY_MAPPINGS[section] || {});

export const ICONS_MAP = {
  'Comfort & convenience': ClimateControl,
  'Technology & connectivity': WirelessDisplay,
  'Safety & security': SafetyBelt,
  'Performance & powertrain': Drivetrain,
  'Dimensions & capacity': Dimension,
} as const;
